<template>
    <div id="main" class="app-main">
      <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
  @import "views/themes/default";

  html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
  }
  .app-main{
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue